import { styled } from '@linaria/react';
import { fonts, layout, semantic, space } from '../../theme/tokens';

export const Bar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 200;
  width: 100%;
  box-sizing: border-box;
  background-color: ${semantic.bg.canvas};
  background-image: linear-gradient(${semantic.bg.surfaceSubtle}, ${semantic.bg.surfaceSubtle});
  padding: ${space['space-400']} ${space['space-1200']};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};

  @media (max-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-300']} ${space['space-900']};
    font-size: ${fonts.size.xs};
  }
`;

export const Content = styled.div`
  & p {
    margin: 0;
  }

  & strong {
    font-weight: ${fonts.weight.semiBold};
  }

  & a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const Heading = styled.span`
  font-weight: ${fonts.weight.semiBold};
  margin-right: ${space['space-200']};
`;

export const Dismiss = styled.button`
  position: absolute;
  top: 50%;
  right: ${space['space-300']};
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: ${space['space-100']};
  color: ${semantic.text.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;
